import { render } from "./Spaceship.vue?vue&type=template&id=4b3ad756"
import script from "./Spaceship.vue?vue&type=script&lang=js"
export * from "./Spaceship.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__